import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterControls = ({ filters, onFilterChange, onReset }) => {
  const regionOptions = [
    { value: 'all', label: 'Semua Region' },
    { value: 'jawa-barat', label: 'Jawa Barat' },
    { value: 'jawa-tengah', label: 'Jawa Tengah' },
    { value: 'jawa-timur', label: 'Jawa Timur' },
    { value: 'banten', label: 'Banten' },
  ];

  const volumeOptions = [
    { value: 'all', label: 'Semua Volume' },
    { value: 'high', label: 'Tinggi (&gt;100L)' },
    { value: 'medium', label: 'Sedang (50-100L)' },
    { value: 'low', label: 'Rendah (&lt;50L)' },
  ];

  const reliabilityOptions = [
    { value: 'all', label: 'Semua Status' },
    { value: 'excellent', label: 'Sangat Baik' },
    { value: 'good', label: 'Baik' },
    { value: 'warning', label: 'Perlu Perhatian' },
    { value: 'critical', label: 'Kritis' },
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Filter & Pencarian</h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={onReset}
          iconName="RotateCcw"
          iconPosition="left"
        >
          Reset
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          placeholder="Cari nama peternak..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Select
          options={regionOptions}
          value={filters?.region}
          onChange={(value) => onFilterChange('region', value)}
          placeholder="Pilih Region"
        />

        <Select
          options={volumeOptions}
          value={filters?.volume}
          onChange={(value) => onFilterChange('volume', value)}
          placeholder="Filter Volume"
        />

        <Select
          options={reliabilityOptions}
          value={filters?.reliability}
          onChange={(value) => onFilterChange('reliability', value)}
          placeholder="Filter Reliabilitas"
        />
      </div>
    </div>
  );
};

export default FilterControls;